<div fxLayout="column">
  <div fxLayout fxLayoutAlign="start center" fxLayoutGap="6px">
    <img src="/assets/iconography/agoda.svg" class="agoda-logo" />
    <h2 class="nomargin">Requirements</h2>
  </div>

  <ng-container>
    <div class="question-box">
      <div fxLayout="column" fxLayoutGap="12px">
        <strong fxFlex>
          Do any of your Agoda listings group multiple rooms or units together as a single listing,
          instead of each unit having its own separate listing?
        </strong>
        <div class="text__small night-lighter">ex. BnB with 2 queen bedrooms which are listed as one room</div>
        <mat-radio-group
          aria-label="Select an option"
          [(ngModel)]="multipleRooms"
          fxLayout="column"
          (change)="progress()">
          <div><mat-radio-button class="full-width-radio-button" [value]="true">Yes, I have a hotel-like setup</mat-radio-button></div>
          <div><mat-radio-button class="full-width-radio-button" [value]="false">No, every property has its own listing</mat-radio-button></div>
        </mat-radio-group>
      </div>
    </div>

  </ng-container>
</div>
